﻿import { NamedValueResponse } from '../../../shared/models/named-value-response.model'

export class Language extends NamedValueResponse {
}